<template>
  <div class="app-container">
    <div class="app-container1"></div>
    <img src="@/assets/vip/mrtlogo.png" alt="名人堂logo" class="mrt-logo">
    <div class="app-container2"></div>

    <!-- 排行榜按钮区域 -->
    <div class="ranking-tabs">
      <div class="tab-item" :class="{ active: currentTab === 'recharge' }" @click="currentTab = 'recharge'">
        周囤币榜
      </div>
      <div class="tab-item" :class="{ active: currentTab === 'activity' }" @click="currentTab = 'activity'">
        周活跃榜
      </div>
      <div class="tab-item" :class="{ active: currentTab === 'points' }" @click="currentTab = 'points'">
        总积分榜
      </div>
    </div>

    <!-- 排行榜内容区域 -->
    <div class="ranking-content">
      <!-- 周囤币榜 -->
      <div v-if="currentTab === 'recharge'">
        <!-- 前三名特殊显示区域 -->
        <div class="top-three-container">
          <!-- 第二名在左边 -->
          <div class="rank-second" v-if="rechargeList.length > 1">
            <div class="avatar-frame avatar-frame-2">
              <img :src="rechargeList[1].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ rechargeList[1].username }}</div>
            <div class="rank-amount">累充值{{ rechargeList[1].pay_money }}</div>
          </div>

          <!-- 第一名在中间 -->
          <div class="rank-first" v-if="rechargeList.length > 0">
            <div class="avatar-frame avatar-frame-1">
              <img :src="rechargeList[0].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ rechargeList[0].username }}</div>
            <div class="rank-amount">累充值{{ rechargeList[0].pay_money }}</div>
          </div>

          <!-- 第三名在右边 -->
          <div class="rank-third" v-if="rechargeList.length > 2">
            <div class="avatar-frame avatar-frame-3">
              <img :src="rechargeList[2].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ rechargeList[2].username }}</div>
            <div class="rank-amount">累充值{{ rechargeList[2].pay_money }}</div>
          </div>
        </div>

        <!-- 第四名及以后的普通列表 -->
        <div class="ranking-list">
          <div class="ranking-item" v-for="(item, index) in rechargeList.slice(3)" :key="index">
            <div class="rank-number">{{ index + 4 }}</div>
            <div class="user-info">
              <img :src="item.avatar" alt="用户头像" class="avatar">
              <div class="user-details">
                <div class="username">{{ item.username }}</div>
              </div>
            </div>
            <div class="vip-level">累充值{{ item.pay_money }}</div>
          </div>
        </div>

        <!-- //底部活动入口// -->
        <!-- <div class="box-mi-ranking">
          <img class="xqyrukou" src="@/assets/vip/mrt-jt.png" alt="">
          <p class="ctext1">点击跳转至活动页</p>
        </div> -->
      </div>

      <!-- 周活跃榜 -->
      <div v-else-if="currentTab === 'activity'">
        <!-- 前三名特殊显示区域 -->
        <div class="top-three-container">
          <!-- 第二名在左边 -->
          <div class="rank-second" v-if="activityList.length > 1">
            <div class="avatar-frame avatar-frame-2">
              <img :src="activityList[1].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ activityList[1].full_name }}</div>
            <div class="rank-score">周成长值{{ activityList[1].number }}</div>
          </div>

          <!-- 第一名在中间 -->
          <div class="rank-first" v-if="activityList.length > 0">
            <div class="avatar-frame avatar-frame-1">
              <img :src="activityList[0].avatar" alt="用户头像" class="rank-avatar gold">
            </div>
            <div class="rank-name">{{ activityList[0].full_name }}</div>
            <div class="rank-score">周成长值{{ activityList[0].number }}</div>
          </div>

          <!-- 第三名在右边 -->
          <div class="rank-third" v-if="activityList.length > 2">
            <div class="avatar-frame avatar-frame-3">
              <img :src="activityList[2].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ activityList[2].full_name }}</div>
            <div class="rank-score">周成长值{{ activityList[2].number }}</div>
          </div>
        </div>

        <!-- 第四名及以后的普通列表 -->
        <div class="ranking-list">
          <div class="ranking-item" v-for="(item, index) in activityList.slice(3)" :key="index">
            <div class="rank-number">{{ index + 4 }}</div>
            <div class="user-info">
              <img :src="item.avatar" alt="用户头像" class="avatar">
              <div class="user-details">
                <div class="username">{{ item.full_name }}</div>
              </div>
            </div>
            <div class="active-days">周成长值{{ item.number }}</div>
          </div>
        </div>
      </div>

      <!-- 总积分榜 -->
      <div v-else-if="currentTab === 'points'">
        <!-- 前三名特殊显示区域 -->
        <div class="top-three-container">
          <!-- 第二名在左边 -->
          <div class="rank-second" v-if="pointsList.length > 1">
            <div class="avatar-frame avatar-frame-2">
              <img :src="pointsList[1].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ pointsList[1].username }}</div>
            <div class="rank-points">总成长值{{ pointsList[1].total_coin }}</div>
          </div>

          <!-- 第一名在中间 -->
          <div class="rank-first" v-if="pointsList.length > 0">
            <div class="avatar-frame avatar-frame-1">
              <img :src="pointsList[0].avatar" alt="用户头像" class="rank-avatar gold">
            </div>
            <div class="rank-name">{{ pointsList[0].username }}</div>
            <div class="rank-points">总成长值{{ pointsList[0].total_coin }}</div>
          </div>

          <!-- 第三名在右边 -->
          <div class="rank-third" v-if="pointsList.length > 2">
            <div class="avatar-frame avatar-frame-3">
              <img :src="pointsList[2].avatar" alt="用户头像" class="rank-avatar">
            </div>
            <div class="rank-name">{{ pointsList[2].username }}</div>
            <div class="rank-points">总成长值{{ pointsList[2].total_coin }}</div>
          </div>
        </div>

        <!-- 第四名及以后的普通列表 -->
        <div class="ranking-list">
          <div class="ranking-item" v-for="(item, index) in pointsList.slice(3)" :key="index">
            <div class="rank-number">{{ index + 4 }}</div>
            <div class="user-info">
              <img :src="item.avatar" alt="用户头像" class="avatar">
              <div class="user-details">
                <div class="username">{{ item.username }}</div>
              </div>
            </div>
            <div class="level">总成长值{{ item.total_coin }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="page-header">
      <img src="@/assets/nav/yz_nav_fh_w.png" alt="返回" class="back-icon" @click="goBack">
      <h1>名人榜</h1>
      <div class="header-right" @click="goIntroduce">
        <p>排名奖励及说明</p>
      </div>
    </div> -->

        <!-- 用户个人信息展示 -->
    <span v-if="currentTab === 'points' || currentTab === 'recharge' " class="box-mi-ranking">
      <div class="mi-ranking">
        <img :src="state.avatar" alt="">
        <div class="chengzhangzhi">
             <p class="chengzhangzhi-text3">{{ state.nicename }}</p>
             <p v-if="currentTab === 'points'" class="chengzhangzhi-text2">{{ state.topinfo && state.topinfo.total_coin }}成长值</p>
            <p v-if="currentTab === 'recharge'" class="chengzhangzhi-text2">我的排名：{{ state.lastpaiming }}</p>
            </div>

        <div class="activity" @click="goTask">
            去活动 
        </div>
       
      </div>
    </span>

    <!-- 添加图片加载动画 -->
    <div v-if="loading" class="loading-overlay">
      <img src="@/assets/animate/loading.gif" alt="加载中" class="loading-image" />
      <p>加载中...</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onActivated, computed, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { mrtpaihang, getLevel, zhouhuoyue } from '@/api/yzCommunity';
import { getQueryString } from '../../../utils/location';
export default {
  name: 'Yxmrt',
  setup() {
    const router = useRouter();
    const store = useStore();

    

    // 状态定义
    const currentTab = ref('recharge'); // 默认显示周囤币榜
    const rechargeList = ref([]); // 周囤币榜数据
    const activityList = ref([]); // 周活跃榜数据
    const pointsList = ref([]); // 总积分榜数据
    const loading = ref(false);
    const state = reactive({
      topinfo: {},
      lastpaiming: "",
      uid: "",
      username: "",
      avatar: "",
      nicename: ""
    });
    // 返回方法
    const goBack = () => {
      router.back();
    };

    // 加载周囤币榜单数据
    const loadRechargeData = async () => {
      loading.value = true;
      try {
        const res = await mrtpaihang({ username: state.username }); // 添加 username 参数

        console.log('===',res)
        if (res && res.data && res.data.data && res.data.data.lastlist) {
          rechargeList.value = res.data.data.lastlist.map(item => {
            return {
              username: item.user_nicename, // 昵称
              avatar: item.avatar, // 头像
              pay_money: item.pay_money // 累充值金额
            };
          });
        }
        if(res && res.data && res.data.data){
          state.lastpaiming = res.data.data.lastpaiming
        }
      } catch (error) {
      } finally {
        loading.value = false; // 无论成功失败，都隐藏加载动画
      }
    };

    // 加载总积分榜数据
    const loadPointsData = async () => {
      loading.value = true;
      try {
        const res = await getLevel({
          uid: state.uid
        });

        if (res && res.data && res.data.code == 1 && res.data.data.toplists) {
          // 只取前10条数据并转换格式
          pointsList.value = res.data.data.toplists.slice(0, 10).map(item => {
            return {
              username: item.user_nicename, // 昵称
              avatar: item.avatar, // 头像
              total_coin: item.total_coin // 总成长值
            };
          });
          console.log('topinfo=',res.data.data.topinfo)
          state.topinfo = res.data.data.topinfo
        }
      } catch (error) {
      }
    };

    // 加载周活跃榜数据
    const loadActivityData = async () => {
      loading.value = true;
      try {
        const res = await zhouhuoyue({
          uid: state.uid
        });
        console.log('周活跃榜接口返回:', res);
        if (res && res.data && res.data.c) {
          // 按照指定格式取数据：data -> c
          activityList.value = res.data.c.map(item => {
            return {
              full_name: item.full_name, // 昵称
              avatar: item.avatar, // 头像
              number: item.number // 周成长值
            };
          });
        }
      } catch (error) {
      } 
    };

    const goTask = ()=>{
      console.log(currentTab.value)
      if(currentTab.value == 'points'){
        // router.push('/personal-page/task')
        window.JsBridge.skipNewTaskActivity();
      }else{
        // router.push('/personal-page/cash-charge')
        window.JsBridge.skipPtbActivity();
      }
    }

    const goIntroduce = ()=>{
        router.push('/personal-page/mine/phbsm')
    }


    onActivated(() => {
      state.username = getQueryString("username")
      state.uid = getQueryString("uid")
      state.avatar = getQueryString("avatar")
      state.nicename = getQueryString("nicename")
      loadRechargeData();
      loadPointsData(); // 同时加载总积分榜数据
      loadActivityData(); // 同时加载周活跃榜数据
    });

    // 组件挂载时加载数据
    onMounted(() => {
      
    });

    return {
      currentTab,
      rechargeList,
      activityList,
      pointsList,
      loading,
      goBack,
      store,
      state,
      goTask,
      goIntroduce
    };
  }
};
</script>

<style scoped>
.app-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* 背景图样式 - 第一张在上半部分 */
.app-container1 {
  width: 750px;
  height: 420px;
  background-image: url('../../../assets/vip/mrtbig1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

/* 背景图样式 - 第二张在下半部分 */
.app-container2 {
  width: 750px;
  height: 1600px;
  background-image: url('../../../assets/vip/mrtbig2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}

/* 添加logo样式，使其显示在背景1上方 */
.mrt-logo {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  width: 750px;
  height: auto;
}

/* 排行榜按钮区域 */
.ranking-tabs {
  position: absolute;
  top: 380px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 3;
  width: 90%;
  background-image: url('../../../assets/vip/anniuBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
}

/* 按钮项 */
.tab-item {
  flex: 1;
  text-align: center;
  padding: 20px 20px;
  color: #fff;
  transition: all 0.3s ease;
  background-size: 100% 100%;
}

.tab-item.active {
  background-image: url('../../../assets/vip/anniu.png');
  font-weight: bold;
}

/* 排行榜内容区域 */
.ranking-content {
  position: absolute;
  top: 500px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  width: 90%;
  max-height: 100%;
  overflow-y: auto;
}

/* 排行榜列表样式 */
.ranking-list {
  background: rgba(255, 255, 255, 0.15);
  border: 4px solid #ffd8ab;
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
}

.box-mi-ranking {
  background: rgba(255, 255, 255, 0.15);
  border: 4px solid #ffd8ab;
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse
}

.xqyrukou {
  width: 50px;
  height: 50px;
}
.ctext1 {
  font-size: 30px;
  color: #fff;
  text-align: center;
}

.ranking-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
}

.rank-number {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  margin-right: 20px;
}

.user-info {
  flex: 1;
  display: flex;
  align-items: center;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
  border: 3px solid #fff;
}

.user-details {
  color: #fff;
}

.username {
  font-size: 28px;
  margin-bottom: 5px;
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vip-level,
.active-days,
.level {
  color: #bdbdbd;
  font-size: 26px;
  padding: 10px 20px;
  border-radius: 15px;
}

/* 前三名特殊样式容器 */
.top-three-container {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px;
  padding: 0;
  width: 100%;
}

/* 第一名样式 - 居中并突出显示 */
.rank-first {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-30px);
  flex: 1;
  z-index: 2;
  animation: floatAnimation 5s ease-in-out infinite;
}

/* 第二名样式 - 左边 */
.rank-second {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  animation: floatAnimation 5s ease-in-out infinite;
}

/* 第三名样式 - 右边 */
.rank-third {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  order: 2;
  animation: floatAnimation 5s ease-in-out infinite;
}

/* 确保前三名元素有足够空间 */
.rank-second,
.rank-first,
.rank-third {
  min-width: 20px;
}

/* 前三名头像框样式 */
.avatar-frame {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

/* 第一名头像框 */
.avatar-frame-1 {
  background-image: url('../../../assets/vip/no1.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 240px;
}

/* 第二名头像框 */
.avatar-frame-2 {
  background-image: url('../../../assets/vip/no2.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  top: 30px;
}

/* 第三名头像框 */
.avatar-frame-3 {
  background-image: url('../../../assets/vip/no3.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  top: 30px;
}

/* 前三名头像样式调整 */
.avatar-frame .rank-avatar {
  position: relative;
  width: 120px;
  border-radius: 50%;
  z-index: -1;
}

/* 名字样式 */
.rank-name {
  color: rgb(255, 201, 51);
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  word-break: break-all;
  white-space: nowrap;
}

/* 周囤币金额样式 */
.rank-amount {
  color: white;
  font-size: 20px;
  opacity: 0.9;
}

/* 周活跃榜积分样式 */
.rank-score {
  color: white;
  font-size: 20px;
  opacity: 0.9;
}

/* 总积分榜积分样式 */
.rank-points {
  color: white;
  font-size: 20px;
  opacity: 0.9;
}

/* 动画效果 */
@keyframes floatAnimation {

  0%,
  100% {
    transform: translateY(-20px);
  }

  50% {
    transform: translateY(-30px);
  }
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  box-sizing: border-box;
  /* 为固定顶部导航栏添加安全区域适配 */
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-top: calc(20px + constant(safe-area-inset-top));
}

/* //返回按钮// */
.back-icon {
  width: 60px;
  height: 60px;
}

.page-header h1 {
  font-size: 32px;
  color: #fff;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-right {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.header-right p {
  font-size: 28px;
  color: #fff;
  text-align: right;
  white-space: nowrap;
}

/* 添加加载动画样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  flex-direction: column;
  text-align: center;
}

.loading-image {
  width: 120px;
  height: 120px;
}

.box-mi-ranking {
  background: #1F1E27;
  border-radius: 48px 48px 0px 0px;
  display: flex;
  width: 750px;
  height: 220px;
  position: fixed;
  background: linear-gradient(#161620 0%, #38363B 100%);
  border: 2px solid #606062;
  /* 设置固定定位 */
  bottom: 0;
  /* 固定在底部 */
  left: 0;
  /* 左对齐 */
  z-index: 999;
  /* 确保在其他内容之上 */
}

.mi-ranking {
  display: flex;
  align-items: center;
  justify-content: center;
  top: 40px;
  position: absolute;
  width: 100%;
  /* 确保容器占满宽度 */
}

.mi-ranking img {
  width: 100px;
  height: 100px;
  margin-left: 32px;
  border-radius: 50%;
  border: 4px solid #fff;
}
.chengzhangzhi {
  flex: 1;
  margin-left: 16px;
}

.chengzhangzhi-text3 {
  font-size: 28px;
  color: #ffffff;
  font-weight: bold;
}

.chengzhangzhi-text2 {
  margin-left: auto;
  /* 使用margin-left: auto将元素推向右侧 */
  font-size: 24px;
  /* 可以调整字体大小 */
  color: #FAE8C9;
  /* 设置与其他文本相同的颜色 */
  margin-right: 32px;
  margin-top: 4px;
}
 .activity{
  width: 176px;
  height: 68px;
  border-radius: 34px;
  background-color: #F5F0B6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 28px;
  color: #2A2930;
  margin-right: 32px;
}
</style>